import { Component, OnInit, Inject } from '@angular/core';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ClonarEstrutura } from 'src/app/models/clonar-estrutura';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { EstruturasPersonalizadas } from 'src/app/models/estruturas-personalizadas';

@Component({
  selector: 'app-clonar-estrutura-modal',
  templateUrl: './clonar-estrutura-modal.component.html',
  styleUrls: ['./clonar-estrutura-modal.component.scss']
})
export class ClonarEstruturaModalComponent implements OnInit {

  fornecedoresEstrutura = [];

  usarTelCeramico = false;
  orientacaoPaisagem = false;

  tiposTelhado = [];

  orientacao = [
    {
      id: 0,
      descricao: 'Retrato'
    },
  ];

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  origemTelhado;
  origemIdFornecedor;
  origemOrientacao;

  destinoTelhado;
  destinoIdFornecedor;
  destinoOrientacao;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private fornecedorEstruturaService: FornecedorEstruturaService,
    private premissasService: PremissasService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ClonarEstruturaModalComponent>
  ) {
    this.origemTelhado = data.origemTelhado;
    this.origemIdFornecedor = data.origemIdFornecedor;
    this.origemOrientacao = data.origemOrientacao;
  }

  async ngOnInit(): Promise<any> {
    await this.buscarEstruturasPersonalizadas();
    this.buscarUsarTelhadoCeramico();
    this.buscarFornecedoresEstrutura();
    this.buscarDesativarPaisagem();
  }

  buscarDesativarPaisagem() {
    this.carregandoService.mostra('buscarDesativarPaisagem');
    this.premissasService.consultarDesativarPaisagem().subscribe(f => {
      this.orientacaoPaisagem = f.valor;

      if (f.valor) {
        this.orientacao = [
          {
            id: 1,
            descricao: 'Paisagem'
          },
          ...this.orientacao
        ];
      }

      this.carregandoService.esconde('buscarDesativarPaisagem');
    }, (erro) => {
      this.carregandoService.esconde('buscarDesativarPaisagem');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarEstruturasPersonalizadas() {

    try {
      this.carregandoService.mostra('consultarEstruturasPersonalizadas');
      this.estruturasPersonalizadas = await this.premissasService.consultarEstruturasPersonalizadas().toPromise();

      this.tiposTelhado = [
        {
          id: 1,
          descricao: 'Fibrocimento'
        },
        {
          id: 8,
          descricao: this.estruturasPersonalizadas.textoFibrometal
        },
        {
          id: 4,
          descricao: 'Metálico'
        },
        {
          id: 7,
          descricao: 'Mini trilho'
        },
        {
          id: 5,
          descricao: 'Laje'
        },
        {
          id: 6,
          descricao: 'Solo'
        },
      ];

      if (this.estruturasPersonalizadas.usarEstruturaCalhetao) {
        this.tiposTelhado.push({ id: 12, nome: this.estruturasPersonalizadas.textoEstruturaCalhetao });
      }

      if (this.estruturasPersonalizadas.usarEstruturaCarport) {
        this.tiposTelhado.push({ id: 13, nome: this.estruturasPersonalizadas.textoEstruturaCarport });
      }

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('consultarEstruturasPersonalizadas');
    }


  }

  buscarUsarTelhadoCeramico() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarUsarTelCeramico().subscribe(f => {
      this.usarTelCeramico = f.valor;

      if (f.valor) {
        this.tiposTelhado = [
          {
            id: 0,
            descricao: 'Cerâmico'
          },
          ...this.tiposTelhado
        ];
      } else {
        this.tiposTelhado = [
          {
            id: 9,
            descricao: 'Colonial'
          },
          {
            id: 10,
            descricao: 'Romana/Americana'
          },
          ...this.tiposTelhado
        ];
      }

      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  buscarFornecedoresEstrutura() {
    this.carregandoService.mostra('buscarFornecedoresEstrutura');

    this.fornecedorEstruturaService.consultarFornecedores().subscribe(
      forns => {
        this.fornecedoresEstrutura = forns;
        this.carregandoService.esconde('buscarFornecedoresEstrutura');
      },
      err => {
        this.carregandoService.esconde('buscarFornecedoresEstrutura');
        this.notificacaoService.erro(err);
      }
    );
  }

  clonar() {
    this.carregandoService.mostra('clonar');

    const vm: ClonarEstrutura = {
      origemIdFornecedor: this.origemIdFornecedor,
      origemTelhado: this.origemTelhado,
      origemOrientacao: this.origemOrientacao,
      destinoIdFornecedor: this.destinoIdFornecedor,
      destinoTelhado: this.destinoTelhado,
      destinoOrientacao: this.destinoOrientacao
    };

    this.fornecedorEstruturaService.clonar(vm).subscribe(
      () => {
        this.carregandoService.esconde('clonar');
        this.notificacaoService.sucesso('Estrutura clonada com sucesso!!!');

        this.dialogRef.close(vm);
      },
      err => {
        this.carregandoService.esconde('clonar');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
